import { CountryData, RouteTransfer } from '@/types/RouteTransferType';
import { removeTildes } from './string';

export function filterCountry(
  { country, currency }: RouteTransfer,
  queryText: string
) {
  const query = String(queryText).toLowerCase();
  const { alpha2Code, dialCode, nameES, nameEN } = country;
  const { code } = currency;
  const obj = { alpha2Code, dialCode, nameES, nameEN, code };
  return Object.values(obj).some((value) =>
    String(removeTildes(value)).toLowerCase().includes(removeTildes(query))
  );
}

export function filterCountryFull(
  { alpha2Code, dialCode, nameES, nameEN }: CountryData,
  queryText: string
) {
  const query = String(queryText).toLowerCase();
  const obj = { alpha2Code, dialCode, nameES, nameEN };
  return Object.values(obj).some((value) =>
    String(value).toLowerCase().includes(query)
  );
}
